// src/shared/changelog/format.ts

/**
 * "2024-06-18" → "June 18, 2024". Parsed as UTC to avoid off-by-one drift
 * across timezones; falls back to the raw string on an unparseable date.
 */
export function formatReleaseDate(iso: string): string {
  const d = new Date(`${iso}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC",
  });
}

/**
 * "2026-06-01" → "June 2026" (month + year, UTC). The derived month heading on
 * the feed and the footer chip's label; falls back to the raw string when
 * unparseable.
 */
export function formatReleasePeriod(iso: string): string {
  const d = new Date(`${iso}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    timeZone: "UTC",
  });
}
